import { useEffect } from 'react';
import { usePaymentReceiptHandler } from '../../../hooks/usePaymentReceiptHandler';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import {
  fetchPayments,
  selectAllPayments,
  selectPaymentsError,
  selectPaymentsStatus,
} from '../../../store/reducers/paymentsReducer';
import { Header } from '../../organisms';
import { PaymentStatusPoller } from '../Dashboard/StageElements/PaymentStatusPoller';
import { PaymentsTable } from './PaymentsTable/PaymentsTable';

export function Payments() {
  const dispatch = useAppDispatch();
  const payments = useAppSelector(selectAllPayments);
  const status = useAppSelector(selectPaymentsStatus);
  const error = useAppSelector(selectPaymentsError);

  const { status: paymentReceiptStatus, paymentId, clearStatus } = usePaymentReceiptHandler();

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchPayments());
    }
  }, [status, dispatch]);

  const isPolling = paymentReceiptStatus && paymentId;

  return (
    <>
      <Header />
      <div className='mb-10'>
        <h1 className='text-2xl md:text-3xl font-bold mb-4 text-gray-800 border-b pb-2'>Online-Zahlungen</h1>

        {isPolling && (
          <div className='mb-4'>
            <PaymentStatusPoller paymentId={paymentId} onComplete={clearStatus} />
          </div>
        )}

        {status === 'loading' && <div className='p-6 text-center text-gray-500'>Lade Online-Zahlungen...</div>}

        {status === 'failed' && <div className='p-6 text-center text-red-600'>Error: {error}</div>}

        {status === 'succeeded' && <PaymentsTable payments={payments} pollingPaymentId={paymentId} />}
      </div>
    </>
  );
}
